import { useEffect, useState } from "react";

import AutoCompleteDropdown from "../../../ui library/components/dropdowns/AutoCompleteDropdown";
import CustomListBox from "../../Documents/UploadDocuments/components/CustomListBox";
import { STRINGS } from "../utils/Strings";
import { tableAutocompleteProps } from "../utils/styles";

export default function ProviderTypes({
  mode = STRINGS.MODE.CREATE,
  initValue,
  repository,
  referralTo,
  onChange,
  providerTypes = [],
  isTableView = false,
}) {
  const [selectedValue, setSelectedValue] = useState(initValue ?? null);
  const [data, setData] = useState([]);
  const [showMore, setShowMore] = useState(false);
  const [nextPage, setNextPage] = useState(null);
  const [searchText, setSearchText] = useState("");

  const parseData = (items) =>
    items.map((item) => ({
      id: item.id,
      key: item.id,
      label: item.name,
    }));

  const fetchData = async (
    search = "",
    limit = STRINGS.DEFAULT_LIMIT,
    offset = STRINGS.DEFAULT_OFFSET
  ) => {
    const params = { limit, offset };
    if (search) {
      params.search = search;
    }

    const response = await repository.query(params);
    const mapped = parseData(response);

    if (offset === 0) {
      setData(mapped);
    } else {
      setData((prev) => [...prev, ...mapped]);
    }

    const next = await repository.getNextPage();
    setNextPage(next);
    setShowMore(!!next);
  };

  const fetchNextPage = async () => {
    if (!nextPage) {
      return;
    }
    const url = new URL(nextPage);
    const newLimit = parseInt(url.searchParams.get("limit"));
    const newOffset = parseInt(url.searchParams.get("offset"));
    await fetchData(searchText, newLimit, newOffset);
  };

  const reset = () => {
    setSelectedValue(null);
    setSearchText("");
    onChange("providerType", null);
  };

  useEffect(() => {
    let isMounted = true;
    const loadData = async () => {
      if (providerTypes && providerTypes.length > 0) {
        const mapped = parseData(providerTypes);
        if (isMounted) {
          setData(mapped);
          setShowMore(false);
        }
      } else {
        if (selectedValue === null) {
          await fetchData("", STRINGS.DEFAULT_LIMIT, STRINGS.DEFAULT_OFFSET);
        } else {
          if (mode === STRINGS.MODE.CREATE) {
            setSelectedValue(null);
          }
          setData([]);
          setShowMore(false);
        }
      }
    };

    loadData();

    return () => {
      isMounted = false;
    };
  }, [providerTypes]);

  useEffect(() => {
    const isEmpty = !providerTypes || providerTypes.length === 0;
    if (isEmpty && selectedValue !== null) {
      setSelectedValue(null);
    }
  }, [providerTypes, selectedValue]);

  useEffect(() => {
    if (providerTypes && providerTypes.length > 0) {
      return;
    }

    const timeout = setTimeout(() => {
      fetchData(searchText, STRINGS.DEFAULT_LIMIT, STRINGS.DEFAULT_OFFSET);
    }, 750);

    return () => clearTimeout(timeout);
  }, [searchText, providerTypes]);

  const handleOnChange = async (value) => {
    if (!value) {
      await reset();
    } else {
      setSelectedValue(value);
      onChange("providerType", value);
    }
  };
  useEffect(() => {
    if (mode === STRINGS.MODE.CREATE) {
      setSelectedValue("");
    }
  }, [referralTo]);

  return (
    <>
      <AutoCompleteDropdown
        key={referralTo}
        freeSolo={true}
        label={isTableView ? "" : "Provider Type*"}
        textFieldSx={isTableView ? tableAutocompleteProps : {}}
        data={data}
        initValue={selectedValue}
        getOptionLabel={(option) => (typeof option === "string" ? option : option.label)}
        onValueChange={(_, value) => handleOnChange(value)}
        onInputChange={(_, newInputValue, reason) => {
          if (reason === "input") {
            setSearchText(newInputValue);
          } else if (reason === "clear") {
            reset();
          }
        }}
        ListboxComponent={CustomListBox}
        ListboxProps={{
          showMore,
          setShowMore: fetchNextPage,
        }}
        filterOptions={(options) => options}
      />
    </>
  );
}
